import { render, staticRenderFns } from "./ShopMob.vue?vue&type=template&id=0b922681&"
import script from "./ShopMob.vue?vue&type=script&lang=js&"
export * from "./ShopMob.vue?vue&type=script&lang=js&"
import style0 from "./ShopMob.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports